import React, {useState} from 'react';
import {Button, GetProp, message, Modal, Upload, UploadFile, UploadProps} from "antd";
import {t} from "i18next";
import IconUploadFile from "../../../ui/icons/IconUploadFile";
import {api} from "../../../../api/apiProvider";
import urls from "../../../../api/urls";
import {DataTotal, MercureEvent, Period} from "../../../../api/types";
import {subscribeTo} from "../../../../mercure";
import {TriggerWithArgs} from "swr/mutation";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

interface UploadFactProps {
  period: Period,
  dataTotals: DataTotal[],
  scrollToBlock: Function,
  setShowHistoricalData: Function,
  mutateDataTotal: TriggerWithArgs<{
    data: DataTotal
  }, any, string, number>,
  isFactData: boolean,
}

const uploadXls = async (formData: any) => {
  return await api.postFile(`${urls.dataTotals}/upload`, {arg: formData})
};

export default function UploadData({
                                     period,
                                     dataTotals,
                                     scrollToBlock,
                                     mutateDataTotal,
                                     setShowHistoricalData,
                                     isFactData,
                                   }: UploadFactProps) {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);
  const [planFileList, setPlanFileList] = useState<UploadFile[]>([]);
  const [isXlsLoading, setIsXlsLoading] = useState<boolean>(false);
  const [mercureState, setMercureState] = useState<String>('');

  const isPeriodAccepted = () => {
    return dataTotals && dataTotals.some((dataTotal: DataTotal) => dataTotal.isAccepted)
  };

  const uploadPlan = () => {
    const formData = new FormData();

    if (!planFileList.length) {
      return
    }

    planFileList.forEach((file): void => formData.append('file', file as FileType));

    formData.append('period', period['@id']);
    formData.append('isFactDataset', isPeriodAccepted() ? '1' : '0');

    setIsXlsLoading(true);

    uploadXls(formData).then(async (response: MercureEvent) => {
      setIsUploadModalOpen(false);

      if (response && response.mercureTopic) {
        const dataTotalId = Number(response.mercureTopic.split('/').pop());

        if (dataTotalId) {
          setIsXlsLoading(false);

          subscribeTo(response.mercureTopic, (successMessage) => {
            if (successMessage) {
              message.success(successMessage)
            }
          }, (errorMessage: string) => {
            message.error(errorMessage)
          }, async (result) => {
            if (result.state !== mercureState) {
              setMercureState(result.state);
              await mutateDataTotal(dataTotalId);
              scrollToBlock(dataTotalId);
              setShowHistoricalData(true);
            }
          });
        }
      }

    }).catch((response) => {
      message.error(response['hydra:description'])
    }).finally(() => {
      setPlanFileList([])
    })
  };

  const getTitle = () => {
    return isPeriodAccepted() ? t('planner.uploadFact') : t('planner.uploadPlan')
  };

  return (
    <>
      <Button
        onClick={() => setIsUploadModalOpen(true)}
        loading={isXlsLoading}
        icon={<IconUploadFile/>}
        disabled={isFactData}
      >
        {getTitle()}
      </Button>

      <Modal
        title={getTitle()}
        open={isUploadModalOpen}
        onOk={uploadPlan}
        onCancel={() => {
          setIsUploadModalOpen(false);
          setPlanFileList([])
        }}
      >
        <Upload
          listType="picture"
          fileList={planFileList}
          onRemove={(file: UploadFile) => {
            const index = planFileList.indexOf(file);
            const newFileList = planFileList.slice();
            newFileList.splice(index, 1);
            setPlanFileList(newFileList);
          }}
          beforeUpload={(file) => {
            setPlanFileList([...planFileList, file]);
            return false
          }}
        >
          <Button
            icon={<IconUploadFile/>}
            size={'large'}
            style={{width: '100%'}}
          >{t('planner.uploadFile')}
          </Button>
        </Upload>
      </Modal>

    </>
  )
}
